import React from 'react';

import { Slider } from '@eliadmin/core/src/components/ui/slider';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function AttributePrice() {
  const max = useCategoryStore(state => state.category.price.max);
  const min = useCategoryStore(state => state.category.price.min) ?? 0;
  const clearTrigger = useCategoryStore(state => state.clearTrigger);
  const [priceRange, setPriceRange] = React.useState<number[]>([min ?? 0, max ?? 100000]);

  const setFilter = useCategoryStore(state => state.setFilter);

  React.useEffect(() => {
    setPriceRange([min ?? 0, max ?? 100000]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTrigger]);

  const handlePriceChange = () => {
    setFilter({ price_min: priceRange[0], price_max: priceRange[1] });
  };

  if (max === null) return null;

  return (
    <div className={cn('flex flex-col gap-4 px-2 pb-2 pt-3', 'ea-attribute-price')}>
      <Slider
        isDual
        value={priceRange}
        min={min}
        max={max}
        aria-label="Price range"
        onValueChange={value => setPriceRange(value)}
        onBlur={handlePriceChange}
      />
      <div
        className={cn('flex w-full flex-row justify-between gap-2', 'ea-attribute-price__wrapper')}
      >
        <p>{priceRange[0]}</p>
        <p>{priceRange[1]}</p>
      </div>
    </div>
  );
}
